export const menuItems = [
  {
    url: '/markets',
    title: 'menu.market.overview',
    icon: 'stats'
  },
  {
    url: '/wallets',
    title: 'menu.wallets',
    icon: 'wallet'
  },
  {
    url: '/transactions',
    title: 'menu.transactions',
    icon: 'history'
  }
];
